export default __webpack_public_path__ + "static/media/graph-build.9d68cdd2.png";